import { gql } from '@apollo/client';

// Hand-written against the backend surface — there is no FE codegen, so a drifted field name fails
// only at runtime (it arrives `undefined`), never at compile time.

export const MATCHING_SELECTION_LIST = gql`
  query matchingSelectionList {
    matchingSelectionList {
      questionnaireId
      displayName
      tier
      startSurroSearch
      state
      country
    }
  }
`;

export const MATCHING_RUN_START = gql`
  mutation matchingRunStart($input: MatchingRunStartInput!) {
    matchingRunStart(input: $input) {
      runId
      status
      droppedQuestionnaireIds
    }
  }
`;

// No `failureReason` (engine-internal, never user-safe — G-d) and no `droppedQuestionnaireIds`
// (always `null` on a poll per the backend DTO).
export const MATCHING_RUN_GET_ONE = gql`
  query matchingRunGetOne($runId: String!) {
    matchingRunGetOne(runId: $runId) {
      runId
      status
      result
    }
  }
`;

export const MATCH_CONFIRMATION_DRAFT = gql`
  query matchConfirmationDraft($applicationId: Int!, $questionnaireId: Int!, $runId: String) {
    matchConfirmationDraft(applicationId: $applicationId, questionnaireId: $questionnaireId, runId: $runId) {
      recipients
      subject
      bodyHtml
      deadlineDate
      attachment {
        status
        folder {
          name
          score
        }
        candidates {
          fileId
          fileName
          folderName
        }
      }
      benefitsAttachment {
        status
        folder {
          name
          score
        }
        candidates {
          fileId
          fileName
          folderName
        }
      }
      priorSends {
        sentOn
      }
    }
  }
`;

// B2b ruling: the browser never fetches Drive bytes directly (this API is Lambda/API Gateway,
// 6MB response cap vs the 10MB attachment ceiling) — this mirrors the existing file-download
// shape (`FILE_DOWNLOAD_ONE`), copying the Drive file to S3 server-side and handing back a
// short-lived presigned URL.
export const MATCH_CONFIRMATION_ATTACHMENT_PREVIEW = gql`
  query matchConfirmationAttachmentPreview($driveFileId: String!) {
    matchConfirmationAttachmentPreview(driveFileId: $driveFileId) {
      url
    }
  }
`;

export const MATCH_CONFIRMATION_SEND = gql`
  mutation matchConfirmationSend($input: MatchConfirmationSendInput!) {
    matchConfirmationSend(input: $input) {
      sentAt
      recipientCount
      steps {
        step
        status
        error
      }
    }
  }
`;
